// extracted by mini-css-extract-plugin
export default {"wrapper":"x8-z","play":"y8-z"};